import React from 'react';
import { BadgeDollarSign } from 'lucide-react';

interface InvoiceTaxTabProps {
  formData: {
    taxAmount: number;
  };
  onFieldChange: (field: string, value: string | number) => void;
}

export const InvoiceTaxTab: React.FC<InvoiceTaxTabProps> = ({ formData, onFieldChange }) => {
  return (
    <div className="space-y-5 text-left">
      <div className="rounded-2xl border border-strivre-lightnavy bg-slate-50/40 p-5">
        <div className="flex items-center gap-3 mb-4">
          <div className="rounded-xl bg-strivre-lightburgundy p-2 text-strivre-burgundy">
            <BadgeDollarSign size={18} />
          </div>
          <div>
            <h4 className="font-semibold text-slate-900">Invoice & Tax Settings</h4>
            <p className="text-sm text-slate-500">Manage invoice defaults and tax configuration.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-700">Tax Rate (%)</label>
            <input
              type="number"
              step="0.01"
              value={formData.taxAmount}
              onChange={(e) => onFieldChange('taxAmount', parseFloat(e.target.value) || 0)}
              className="w-full bg-white border border-strivre-lightnavy rounded-xl px-4 py-2.5 text-slate-900 focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all"
              placeholder="Enter tax rate (%)"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-700">Invoice Prefix</label>
            <input
              type="text"
              value=""
              disabled
              className="w-full cursor-not-allowed bg-strivre-softgrey border border-strivre-lightnavy rounded-xl px-4 py-2.5 text-slate-500"
              placeholder="Coming Soon"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-700">Default Payment Terms (days)</label>
            <input
              type="number"
              value=""
              disabled
              className="w-full cursor-not-allowed bg-strivre-softgrey border border-strivre-lightnavy rounded-xl px-4 py-2.5 text-slate-500"
              placeholder="Coming Soon"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-700">Invoice Footer Notes</label>
            <textarea
              value=""
              disabled
              className="w-full cursor-not-allowed bg-strivre-softgrey border border-strivre-lightnavy rounded-xl px-4 py-2.5 text-slate-500 min-h-[96px]"
              placeholder="Coming Soon"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
